export const TIME_INPUT_TYPE_MINUTES_INTEGER = 'minutesInteger';
export const TIME_INPUT_TYPE_HOURS_DECIMAL = 'hoursDecimal';